<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'modules.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Nome</th>
                                        <th>Icon</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-show="modules.length > 0"
                                        v-for="iterator in modules" 
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>{{ iterator.name }}</td>
                                        <td><i class="material-icons">{{ iterator.icon }}</i></td>
                                        <td class="td-actions text-right">
                                            <index-buttons
                                                :iterator=iterator
                                                :showAudit="true"
                                                :toAudit="{name: 'dashboard'}"
                                                :showEdit="true"
                                                :toEdit="{name: 'modules.edit', params: { id: iterator.id }}"
                                                :showRemove="true"
                                                dispatchRemove="modules/rem"
                                                :callbackRemove="getData"
                                                >
                                            </index-buttons>
                                        </td>
                                    </tr>
                                    <tr v-show="modules.length==0">
                                        <td colspan="4">Nenhum módulo encontrado!</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            modules() {
                return this.$store.state.modules.itens;
            }
        },
        created: function () {
            this.getData();
        },
        data() {
            return {
                currentPage: 1
            };
        },
        methods: {
            remove: function (_module) {
                var self = this;
                this.$dialog.confirm('Deseja realmente remover o módulo "' + _module.name + '"?')
                        .then(function () {
                            self.$root.$emit('onLoading');
                    
                            const response = self.$store.dispatch('modules/rem', _module);

                            response.then(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.success("Módulo excluído com sucesso!");
                                self.getData();
                            });

                            response.catch(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.danger("Não foi possível excluir o módulo!");
                            });
                        });
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('modules/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
        }
    }
</script>